import React,{useState,useEffect} from 'react'
import { withRouter } from 'react-router';
import headerBG from "../../../resources/BG.png";
import {  female, male } from "../../../utils/tecahersCard/index";
import { Grid} from 'semantic-ui-react'


function MobileView(props) {

    const handleCardClick = (index, type, className) => {
      props.history.push({
        pathname: '/details',
        state: { 
          imageKey: index,
          type : type,
          className: className
        }
      })
    }

  return (
    <div className="welcome-page">

      <div id="header">
        <img id="headerBG" src={headerBG} />
      </div>

      <div id="welcomePage-detail">
        <div id="welcomePage-header">
          <div id="welcomePage-wishTeacher">
            <p id="reliveYourClassroom">
            Kaun hai apka class wala dost?


            </p>
            <p id="missingYourClassroom">
            Class me pen fight khelne se lekar, Class ke baad samose khane tak. #ClassWaliDosti hoti hai sabse special. Bataiye kaun hai vo dost jisne banayi aapki class aur bhi special.
            </p>
            
          </div>


        </div>

        <div id="student-teachersCard">
          <p id="bringBack-memories">Tell us what you and your friend did in class</p>
            <p id="choose-card" >Choose kare ek memory aur batayein kaun hai apka #ClassWaliDosti ka saathi.</p>
            <Grid columns={2} >
              <div className="welcomepage-categoryLabel">Sir wali class ki #ClassWaliDosti</div>
              <Grid.Row >
                {male.map((image,index) => {
                  return (
                    <Grid.Column style={{marginTop:"1%",padding:"3%"}}>
                      <img index={index} src={image.coverImg} className="cards-image"  onClick={(e)=>handleCardClick(index, "male", image.class)} />
                    </Grid.Column>
                  );
                })}
              </Grid.Row>
              <div className="welcomepage-categoryLabel">Ma'am wali class ki #ClassWaliDosti</div>
              <Grid.Row >
                {female.map((image,index) => {
                  return (
                    <Grid.Column style={{marginTop:"1%",padding:"3%"}}>
                      <img index={index} src={image.coverImg} className="cards-image"  onClick={(e)=>handleCardClick(index, "female", image.class)} />
                    </Grid.Column>
                  );
                })}
              </Grid.Row>

            </Grid>
          </div>
      </div>
    </div>
  );
}

export default withRouter(MobileView)
